import DocumentDialog from "./dialogs/DocumentDialog/DocumentDialog";
import { ProjectAddDialog } from "./dialogs/ProjectAddDialog/ProjectAddDialog";
import { SettingsPipeSeriesAddDialog } from "./dialogs/SettingsPipeSeriesAddDialog/SettingsPipeSeriesAddDialog";
import { SettingsPipeSeriesDialog } from "./dialogs/SettingsPipeSeriesDialog/SettingsPipeSeriesDialog";
import { SettingsUnitsEditDialog } from "./dialogs/SettingsUnitsEdit/SettingsUnitsEditDialog";
import { SettingsWaterCharacteristicsDialog } from "./dialogs/SettingsWaterCharacteristicsDialog/SettingsWaterCharacteristicsDialog";

export const routeDialogs = [
  {
    element: <ProjectAddDialog />,
    path: "project.add" as const,
  },
  {
    element: <SettingsUnitsEditDialog />,
    path: "settings.units.edit" as const,
  },
  {
    element: <SettingsWaterCharacteristicsDialog />,
    path: "settings.waterCharacteristics" as const,
  },
  {
    element: <SettingsPipeSeriesDialog />,
    path: "settings.pipeSeries" as const,
  },
  {
    element: <SettingsPipeSeriesAddDialog />,
    path: "settings.pipeSeries.add" as const,
  },
  {
    element: <DocumentDialog />,
    path: "document.open" as const,
  },
];

export type RouteDialogPath = (typeof routeDialogs)[number]["path"];
